const rowTemplate = (payment, i) => {
  return `
  <tr>
    <td>${i + 1}</td>
    <td>${payment.project_name}</td>
    <td>${payment.unit_serial}</td>
    <td>${payment.payment_type}</td>
    <td>${payment.cheque_number}</td>
    <td>${payment.payment_date}</td>
    <td>${payment.debit || "-"}</td>
    <td>${payment.credit || "-"}</td>
    <td>${payment.balance}</td>
  </tr>
  `;
};

export const printAccountStatement = (
  { base },
  lead,
  payments: any[],
  totalBalance
) => {
  // data
  const table_data = payments.map((payment, index) =>
    rowTemplate(payment, index + 1)
  );
  // prepare data

  return `<!DOCTYPE html>
  <html lang="ar" dir="rtl">
    <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Account Statement</title>

      <link rel="stylesheet" href="${base}assets/css/vendor/bootstrap.rtl.min.css" />

      <style>
        body {
          font-size: 14px;
        }

        p {
          margin: 0;
        }

        #logo {
          width: 90%;
          max-height: 100%;
        }

        .bg-secondary {
          background-color: #bfbfbf !important;
        }
        @media print {
          * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }

        /* font-sizes */
        .fs-14px {
          font-size: 14px !important;
        }
        .fs-16px {
          font-size: 16px !important;
        }
        .fs-18px {
          font-size: 18px !important;
        }
        .fs-20px {
          font-size: 20px !important;
        }
        .fs-20px {
          font-size: 20px;
        }
      </style>
    </head>
    <body class="bg-light pt-3">
      <div class="container">
        <div class="row">
          <div class="col-8">
          حسابات العملاء
          </div>
          <div class="col-4">
            <img src="${base}assets/img/ww-logo.png" alt="" id="logo" class="d-block m-auto" />
          </div>
        </div>
        <hr />
        <div class="d-flex flex-column">
          <p class="lead fs-16px"><b>اسم العميل:</b> ${lead.name}</p>

          <p class="lead fs-16px"><b>البريد الالكتروني:</b> ${lead.email}</p>

          <p class="lead fs-16px"><b>رقم الهاتف:</b> ${[
            lead.phone,
            lead.phone_2,
            lead.phone_3,
            lead.phone_4,
            lead.phone_5,
            lead.phone_6,
          ]
            .filter((a) => a)
            .join(", ")}</p>

          <p class="lead fs-16px"><b>العنوان:</b> ${lead.address}</p>

          <p class="lead fs-16px"><b>الرقم القومي:</b> ${lead.national_num}</p>

        </div>

        <div class="table-template mt-4">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>م</th>
                  <th>المشروع</th>
                  <th>رقم الوحدة</th>
                  <th>النوع</th>
                  <th>رقم الشيك</th>
                  <th>التاريخ</th>
                  <th>دين</th>
                  <th>ائتمان</th>
                  <th>رصيد الحساب</th>
                </tr>
              </thead>
              <tbody>
              ${table_data.join("")}
                <tr>
                  <th colspan="8">رصيد الحساب</th>
                  <th>${totalBalance}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div id="footer">
          <div class="row mt-3">
            <div class="col-4 text-center">حسابات العملاء</div>
          </div>
          <div class="text-center pt-5">
            وتفضلوا بقبول فائق الاحترام و التقدير ،،،،
          </div>
        </div>
      </div>
    </body>
  </html>
  `;
};



// WEBPACK FOOTER //
// ./src/app/financial/account-statement-view/accountStatementPrint.ts